import Img from "components/atoms/Img";
import FormCountries from "components/molecules/FormCountries";
import PageType from "components/molecules/PageType";
import RefundGuarantee from "components/molecules/RefundGuarantee";
import Banner from "components/organisms/Banner";
import Faqs from "components/organisms/Faqs";
import HowItWorks from "components/organisms/HowItWorks";
import NewsSlider from "components/organisms/NewsSlider";
import PackagesNews from "components/organisms/PackagesNews";
import RequiredDocument from "components/organisms/RequiredDocument";
import WhatMakeUsDifferent from "components/organisms/WhatMakeUsDifferent";

import OffshoreCompanyRegistration from "./OffshoreCompanyRegistration";

const BelizeCompanyFormationTemplate = ({ data, dataJson, ...props }) => {
  const { country } = dataJson;

  return (
    <>
      <Banner
        minHeightBanner="banner-min-h-635"
        breadcrumbs={dataJson.breadcrumbs}
        title={`${country} <br/>Company Formation`}
        titleProps={{
          className: "banner-default-title mb-6 lg:mb-10",
          textColor: "banner-title-default-color",
        }}
        dataTrustpilot={{
          dataStatic: dataJson.dataTrustpilot,
          dataDefault: data.dataTrustpilot,
        }}
        leftClassName="lg:col-7"
        rightClassName="lg:col-5"
        rightContent={
          <Img
            wrapper={{
              className: "bbc-banner-image-country pb-[98px] lg:pb-0",
            }}
            src={`/assets/images/offshore/country/${dataJson.banner_image}`}
            className="w-full "
            width={560}
            height={456}
            priority={true}
            alt={dataJson.imageAlt}
          />
        }
        bgColor={"bg-bbc-country"}
      >
        <div className="hidden py-6 lg:block"></div>
      </Banner>
      <div className="absolute left-1/2 -translate-x-1/2 -translate-y-[74px] text-center lg:-translate-y-1/2">
        <PageType data={dataJson.dataPageType} />
      </div>
      <section className="mt-10 lg:mt-20">
        <OffshoreCompanyRegistration data={dataJson.dataRegistration} />
      </section>
      <Img
        src="/assets/images/wave/top-wave.png"
        width={1920}
        height={125}
        className="w-full"
        wrapper={{ className: "w-full" }}
        alt="Wave top"
      />
      <div className="bg-bbc-package">
        <div className="container ">
          {/* <Packages
            data={data?.dataPackage || []}
            dataStatic={dataJson.dataPackage}
            title={
              (country === "United Kingdom" ? "UK" : country) +
              " Company Formation Packages"
            }
          /> */}
          <PackagesNews
            data={data?.dataPackage || []}
            dataStatic={dataJson.dataPackage}
            title={`${
              country === "United Kingdom" ? "UK" : country
            } Company Formation Packages`}
            subFeeArr={props.subFeeArr}
          />
          <RefundGuarantee className="mb-10 pt-6 lg:mb-20 lg:pt-10" />
        </div>
        <WhatMakeUsDifferent
          title="Bring your next business venture online"
          data={dataJson.dataWhatMakeUsDifferent}
          className="bg-wmud py-[60px]"
        />
        <HowItWorks
          title={country}
          subTitle="Company Incorporation Process"
          data={dataJson.dataHowItWorks}
          className="py-10 lg:py-20"
        />
        <RequiredDocument
          title={dataJson.dataRequiredDocument.title || "Required Documents"}
          data={dataJson.dataRequiredDocument}
          sectionClassName="py-10 lg:py-20"
          backgroundImage="/assets/images/common/required-documents.png"
        />
      </div>
      <section className="relative">
        <div className=" absolute hidden h-1/2 w-full bg-bbc-package md:block"></div>
        <div className="container relative  z-10 pt-10 lg:pt-20">
          <div className="m-auto lg:col-10">
            <FormCountries
              title={dataJson.dataFormContact.title}
              description={dataJson.dataFormContact.description}
              country_id={dataJson.dataFormContact.country_id}
            />
          </div>
        </div>
        <Img
          src="/assets/images/wave/bottom-wave.png"
          width={1920}
          height={140}
          className="w-full"
          wrapper={{ className: "absolute w-full top-1/2 hidden md:block" }}
          alt="Wave bottom"
        />
      </section>
      <section>
        <div className="container">
          <div className="lg:col-10 lg:m-auto">
            <Faqs
              data={dataJson.dataFaqs}
              title={dataJson.dataFaqs.title}
              description={dataJson.dataFaqs.description}
              defaultActiveKey={dataJson.dataFaqs.defaultActiveKey}
              multipleOpen={dataJson.dataFaqs.multipleOpen}
            />
          </div>
        </div>
      </section>
      <section className="mb-0">
        <div className="container">
          <NewsSlider data={data} />
        </div>
      </section>
    </>
  );
};

export default BelizeCompanyFormationTemplate;
